import { registerComponent } from '@gig/magic-common';
import RgLimitsPropmterComponent from './rg-limits-prompter.js';

var RgLimitsPropmter = registerComponent(RgLimitsPropmterComponent);

export { RgLimitsPropmter };
